import React from 'react'
import { Platform, View } from 'react-native'
import globalStyle from '../../../styles/globalStyle';
import { HeaderScreen } from '../../../components/Header/HeaderScreen';
import { PageContainer } from '../../../components/PageContainer';
import { MenuItem } from '../../../components/MenuItem';
import { sinistresList } from '../../../../data/constants/Sinistres/sinistre';

export const DeclarerSinistre = () => {
    return (
        <View>
            <HeaderScreen title="Mes sinistres" type="retour" noBreadcrumb={false} />
            <PageContainer>
                <View style={Platform.OS==='web'?[globalStyle.containerFluid, {padding: 8}]:[globalStyle.mobileContainerFluid]}>
                    <MenuItem data={sinistresList} isHome={false} />
                </View>
            </PageContainer>
        </View>
    )
};
